import { Component, EventEmitter, Input, Output } from '@angular/core';
import * as _moment from 'moment';
import {
  MomentDateAdapter,
  MAT_MOMENT_DATE_ADAPTER_OPTIONS,
} from '@angular/material-moment-adapter';
import {
  DateAdapter,
  MAT_DATE_FORMATS,
  MAT_DATE_LOCALE,
  NativeDateAdapter,
} from '@angular/material/core';
import { MatDatepicker, MatDatepickerInputEvent, MatDatepickerModule } from '@angular/material/datepicker';
import { FormControl, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import moment from 'moment';
import { Platform } from '@angular/cdk/platform';
import { MaterialModule } from 'src/app/material.module';
import { CommonModule } from '@angular/common';
import { IconModule } from 'src/app/icon/icon.module';
import { provideNativeDateAdapter } from '@angular/material/core';

export class MonthpickerDateAdapter extends NativeDateAdapter {
  constructor(matDateLocale: string, platform: Platform) {
    super(matDateLocale);
  }

  override parse(value: string): Date | null {
    const monthAndYearRegex = /(10|11|12|0\d|\d)\/[\d]{4}/;
    if (value?.match(monthAndYearRegex)) {
      const parts = value.split('/');
      const month = Number(parts[0]);
      const year = Number(parts[1]);
      if (month > 0 && month <= 12) {
        return new Date(year, month - 1);
      }
    }
    return null;
  }

  override format(date: Date, displayFormat: any): string {
    const month = date.getMonth() + 1;
    const monthAsString = ('0' + month).slice(-2);
    const year = date.getFullYear();
    return monthAsString + '/' + year;
  }
}

@Component({
  selector: 'app-month-datepicker',
  templateUrl: './month-datepicker.component.html',
  styleUrl: './month-datepicker.component.scss',
  providers: [
    provideNativeDateAdapter(),
    {
      provide: DateAdapter,
      useClass: MonthpickerDateAdapter,
      deps: [MAT_DATE_LOCALE, Platform],
    },
  ],
  standalone: true,
  imports: [
    MaterialModule,
    IconModule,
    FormsModule,
    CommonModule,
    ReactiveFormsModule,
  ]
})

export class MonthDatepickerComponent {
  @Input() label: string = 'Choose a month';
  @Output() selectedYear = new EventEmitter<number>();

  @Input()
  public monthAndYear: Date | null = null;

  @Output()
  public monthAndYearChange = new EventEmitter<Date | null>();

  date = new FormControl(moment());

  emitDateChange(event: MatDatepickerInputEvent<Date | null, unknown>): void {
    this.monthAndYearChange.emit(event.value);
  }

  monthChanged(value: any, widget: any): void {
    this.monthAndYear = value;
    widget.close();
    this.monthAndYearChange.emit(value);
  }

}